import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import './Home.css';
import profileImage from '../assets/images/profile.jpg';
import FAQ from '../components/FAQ';

const Home = () => {
  return (
    <div className="home">
      <Helmet>
        <title>Sipelius Kotipalvelu - Kotipalvelut, senioriapu ja kotisiivous | Lahti, Hollola, Heinola</title>
        <meta name="description" content="Sipelius Kotipalvelu tarjoaa luotettavia kotipalveluita, senioriapua ja kotisiivousta Lahdessa, Hollolassa, Heinolassa ja Orimattilassa. Senioripalvelut, henkilökohtainen apu ja pihatyöt. 38€/tunti." />
        <meta name="keywords" content="kotipalvelu Lahti, senioriapu Lahti, senioripalvelut Lahti, kotisiivous Lahti, kotipalvelu Hollola, kotipalvelu Heinola, kotipalvelu Orimattila, kotisiivous Hollola, senioriapu Hollola, lähihoitaja, kodinhoito, henkilökohtainen apu, pihatyöt" />
        <link rel="canonical" href="https://sipelius-kotipalvelu.fi/" />
        <meta property="og:title" content="Sipelius Kotipalvelu - Kotipalvelut, senioriapu ja kotisiivous | Lahti, Hollola, Heinola" />
        <meta property="og:description" content="Luotettavia kotipalveluita, senioriapua ja kotisiivousta Lahdessa, Hollolassa, Heinolassa ja Orimattilassa. Senioripalvelut, henkilökohtainen apu ja pihatyöt. 38€/tunti." />
        <meta property="og:url" content="https://sipelius-kotipalvelu.fi/" />
        <meta property="og:type" content="website" />
      </Helmet>
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1>Henkilökohtaista senioriapua ja kotipalveluita</h1>
            </div>
            
            <div className="hero-main">
              <div className="hero-story">
                <p>
                  Moi! Haluan kertoa vähän itsestäni ja miksi teen tätä työtä. Oon yksinyrittäjä ja pistän tähän hommaan itseni täysillä joka päivä! On hienoa saada tehdä just sitä, mikä itseltä hyvin luonnistuu ja ihan omin käsin.
                </p>
                <p>
                  Mulla on pitkä kokemus kotihoidosta eri puolilta Suomea. Sen lisäksi erilaiset askareet arjessa onnistuvat mulla kätevästi, ja nuoruuden opit maataloustöistä ja puutarhanhoidosta on edelleen tallella. Tarvittaessa tuun vaikka auttamaan navetassa taas! Palveluista löytyy joustoa juuri sun tarpeeseen.
                </p>
                <p>
                  Yrittäjän polku on opettanut mulle rohkeutta, sitkeyttä ja luovuutta, ja vaikka haasteita tulee, jokainen saavutettu asia tuntuu tosi palkitsevalta. Ja mikä tärkeintä: kun valitset mut, saat aina palvelua suoraan multa itseltäni, tutulta ja turvalliselta kasvolta. Ei mitään vaihtuvia työntekijöitä. Ja tietysti, palvelukieleni on aina suomi.
                </p>
                <p>
                  Tuu mukaan mun matkaan ja nähdään, miten yhdessä saadaan arjesta sujuvampaa
                </p>
              </div>
              
              <div className="hero-profile">
                <div className="profile-card">
                  <div className="profile-image">
                    <img src={profileImage} alt="Riikka - Laillistettu lähihoitaja ja Sipelius kotipalvelun perustaja" />
                    <div className="quote-marks">
                      <svg width="76" height="59" viewBox="0 0 76 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M60.0423 59C57.8228 59 55.6798 58.6296 53.6133 57.8889C51.5468 57.0741 49.7482 55.8889 48.2175 54.3333C46.6868 52.7037 45.4622 50.7407 44.5438 48.4444C43.6254 46.0741 43.1662 43.3333 43.1662 40.2222C43.1662 28.5926 50.7432 15.1852 65.8973 0L76 9.44444C74.3928 10.9259 72.7855 12.5185 71.1782 14.2222C69.6475 15.9259 68.2316 17.6667 66.9305 19.4444C65.7059 21.1481 64.6344 22.8889 63.716 24.6667C62.7976 26.3704 62.1088 27.963 61.6495 29.4444C66.0121 29.8148 69.4945 31.4074 72.0967 34.2222C74.6989 37.037 76 40.3333 76 44.1111C76 46.1111 75.6173 48 74.852 49.7778C74.0866 51.5556 73.0151 53.1481 71.6375 54.5556C70.2598 55.8889 68.576 56.963 66.5861 57.7778C64.5962 58.5926 62.4149 59 60.0423 59ZM16.8761 59C14.6566 59 12.5136 58.6296 10.4471 57.8889C8.38066 57.0741 6.58207 55.8889 5.05136 54.3333C3.52064 52.7037 2.29607 50.7407 1.37764 48.4444C0.459215 46.0741 0 43.3333 0 40.2222C0 28.5926 7.57704 15.1852 22.7311 0L32.8338 9.44444C31.2266 10.9259 29.6193 12.5185 28.0121 14.2222C26.4814 15.9259 25.0655 17.6667 23.7644 19.4444C22.5398 21.1481 21.4683 22.8889 20.5498 24.6667C19.6314 26.3704 18.9426 27.963 18.4834 29.4444C22.8459 29.8148 26.3283 31.4074 28.9305 34.2222C31.5327 37.037 32.8338 40.3333 32.8338 44.1111C32.8338 46.1111 32.4512 48 31.6858 49.7778C30.9204 51.5556 29.8489 53.1481 28.4713 54.5556C27.0937 55.8889 25.4099 56.963 23.4199 57.7778C21.43 58.5926 19.2487 59 16.8761 59Z" fill="#804d41"/>
                      </svg>
                    </div>
                  </div>
                  <div className="profile-info">
                    <p><em>Hei!</em></p>
                    <p><em>Olen Riikka,</em></p>
                    <p><em>laillistettu lähihoitaja</em></p>
                    <p><em>Sipelius kotipalvelun yrittäjä ja perustaja</em></p>
                  </div>
                  <a href="mailto:sipeliuskotipalvelu@gmail.com" className="contact-button">
                    Ota minuun yhteyttä
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services">
        <div className="container">
          <div className="services-header">
            <h3 className="accent-color">Miksi työskennellä kanssani</h3>
            <h2>Kotipalvelut ja senioriapu Lahdessa ja lähikunnissa</h2>
          </div>
          
          <div className="services-content">
            <div className="services-text">
              <div className="service-item">
                <h2>Kokonaisvaltaista apua kotiin ja henkilökohtaisiin tarpeisiin</h2>
                <p>
                  Tarjoan laadukkaita kotipalveluita ja kotisiivousta Lahdessa, Hollolassa, Heinolassa ja Orimattilassa. <Link to="/palvelut">Siivouspalveluni</Link> kattavat kaikki kodin tarpeet perusteellisesta pintojen pyyhkimisestä imurointiin ja lattioiden pesuun — olipa kyseessä kiireinen lapsiperhe tai ikäihmisen koti.
                </p>
                <p>
                  Lisäksi tarjoan <Link to="/palvelut">senioripalveluita ja henkilökohtaista apua</Link>, kuten asiointiavustusta, peseytymisapua ja seuranpitoa. <Link to="/hinnasto">Kaikki palveluni ovat saatavilla 38€/tunti</Link>.
                </p>
              </div>
              
              <div className="service-item">
                <h2>Yksilöllinen Asiakaspalvelu</h2>
                <p>
                  Panostan täysillä siihen, että jokainen asiakas saa juuri hänelle sopivaa, yksilöllistä palvelua. Minulle on tärkeintä ymmärtää sinun tarpeesi ja toiveesi ja kuunnella niitä tarkasti. Teen aina parhaani varmistaakseni, että olet tyytyväinen saamaasi apuun. <Link to="/yhteystiedot">Ota yhteyttä</Link> niin keskustellaan tarpeistasi.
                </p>
              </div>
              
              <div className="service-item">
                <h2>Luotettavuus ja Joustavuus</h2>
                <p>
                  Minut tunnetaan luotettavana ja joustavana tekijänä kotiin. Saavun aina sovittuun aikaan ja hoidan kaikki tehtävät ammattitaitoisesti ja huolellisesti. Räätälöin palveluni juuri sinun tarpeidesi ja toiveidesi mukaiseksi, jotta saat aina parasta mahdollista apua.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <FAQ />
    </div>
  );
};

export default Home; 